<template>
  <v-container class="management-tabs__container py-0 pb-16">
    <DraftFilter/>
    <DraftData v-if="showDataTable"/>
  </v-container>
</template>

<script>
  import DraftFilter from '../../components/draft/DraftFilter';
  import DraftData from '../../components/draft/DraftData';

  export default {
    name: 'Draft',

    components: {DraftData, DraftFilter},

    mounted: function () {
      // Google Analytics
      ga('set', 'page', 'management/draft-visits');
      ga('send', 'pageview');
      // End Google Analytics
    },

    computed: {
      showDataTable: function () {
        return this.$store.state.draft.showDataTable;
      },
    },

    destroyed: function () {
      this.$store.commit('draft/updateShowDataTable', false);
    },
  };
</script>
